import { GenTableComponent } from "@app/gen-table/gen-table.component"
import { CcParamsGen } from "./../cc-params-gen/cc-params-gen"
import { Component, Input, OnInit, ViewChild } from "@angular/core"
import {
	ConfigDefinitions,
	AccountantScheduledReport,
	FollowupserieSave,
} from "@app/definitions/types"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { OptionsList } from "@app/definitions/opts"
import { pluck } from "@app/services/api.service"

@Component({
	selector: "app-cc-params-credit-clearance",
	templateUrl: "./cc-params-credit-clearance.component.html",
})
export class CcParamsCreditClearanceComponent extends CcParamsGen {
  openCreateTakbullAccount() {
    this.modalService.openMulti("create-takbull-account")
  }
  openCreateGrowAccount() {
    this.modalService.openMulti("create-grow-account")
  }
}
